import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import DetailsChartWrapper from '../components/charts/details/DetailsChartWrapper'
import DetailsNavigation from '../components/navigations/DetailsNavigation'
import { addDays, format } from 'date-fns'
import { useDate } from '@/modules/drivers/stores/dateStore'
import useDriverActivityService from '@/modules/drivers/services/DriverActivityService'
import { useLoadingStore } from '@/modules/shared/stores/loadingStore'
import { ActivityInfo } from '@/modules/drivers/types/activities'
import { useActivity } from '@/modules/drivers/stores/activityStore'

const Details = () => {
  const { companyId, driverId, date: currentDate } = useParams<{
    companyId: string
    driverId: string
    date: string
  }>()
  const navigate = useNavigate()

  const { getDriverActivity } = useDriverActivityService()
  const startLoading = useLoadingStore((s) => s.startLoading)
  const { setType, refreshTrigger } = useActivity()
  const { formatApiDate } = useDate()

  const [data, setData] = React.useState<ActivityInfo | null>(null)

  const getDailyActivity = async () => {
    const stopLoading = startLoading()
    try {
      const dateObj = new Date(currentDate)
      const result = await getDriverActivity({
        companyId,
        driverId: Number(driverId),
        startTime: formatApiDate(dateObj),
        endTime: formatApiDate(addDays(dateObj, 1)),
        includeTrips: true,
      })
      setData(result || null)
    } catch (error) {
      console.error('Daily: Error fetching daily activity:', error)
    } finally {
      stopLoading()
    }
  }

  const goToDate = (days: number) => {
    const [year, month, day] = currentDate.split('-').map(Number)
    const date = new Date(year, month - 1, day)

    if (isNaN(date.getTime())) {
      console.error('Invalid date:', currentDate)
      return
    }

    const next = format(addDays(date, days), 'YYYY-MM-DD')
    navigate(
      `/et/company/${companyId}/driverModule/activities/driver/${driverId}/details/${next}`,
    )
  }

  React.useEffect(() => {
    getDailyActivity()
  }, [driverId])

  React.useEffect(() => {
    setType('details')
  }, [])

  React.useEffect(() => {
    if (refreshTrigger > 0) {
      getDailyActivity()
    }
  }, [refreshTrigger])

  return (
    <div className="tw-h-fit tw-overflow-y-auto">
      <DetailsNavigation currentDate={currentDate} goToDate={goToDate} />
      <DetailsChartWrapper data={data} currentDate={currentDate} />
    </div>
  )
}

export default Details
